module.exports = __webpack_public_path__ + "img/profile-bg2.57e9db61.jpg";